import moment from "moment";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Slider from "react-slick";
import Bg01 from "src/assets/images/bg_banner01.png";
import Bg02 from "src/assets/images/bg_banner02.png";
import Bg03 from "src/assets/images/bg_banner03.png";
import Bg04 from "src/assets/images/bg_banner04.png";
import Bg05 from "src/assets/images/bg_banner05.png";
import { lPad } from "src/utils/lPad";
import SVG from "src/utils/SVG";
import styled from "styled-components";

interface IHomeBannerProps {
  data: any[];
}

const MainBanner = (props: IHomeBannerProps) => {
  const [noticeBannerData, setNoticeBannerData] = useState(props.data);
  const [currentSlide, setCurrentSlide] = useState(0);

  const setBannerSlide = {
    useTransform: false,
    dots: false,
    infinite: true,
    speed: 1000,
    autoplay: true,
    autoplaySpeed: 3000,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    cssEase: "ease-out",
    beforeChange: function (oldIdx: number, newIdx: number) {
      setCurrentSlide(newIdx);
    },
  };

  return (
    <div style={{ position: "relative" }}>
      {noticeBannerData && noticeBannerData.length > 0 ? (
        <>
          <BannerSlider {...setBannerSlide}>
            {noticeBannerData.map((v: any, i: number) => {
              return (
                <Link to={`/notice-detail/` + v.notice_idx} key={i}>
                  <BannerSlideItem>
                    <div className="bg-img">
                      <p className="title">{v.title ? v.title : "제목없음"}</p>
                      <p className="sub-info">
                        <span className="date">{moment(v.insert_date).format("YYYY.MM.DD")}</span>
                        <span className="cmt">
                          <SVG name="chatWhite" width={12.967} height={13.205} viewBox="0 0 12.967 13.205" />
                          {v.comment_count}
                        </span>
                      </p>
                    </div>

                    <CustomPaging>
                      <span>{lPad(currentSlide + 1, 2, 0)}</span>
                      {lPad(noticeBannerData.length, 2, 0)}
                    </CustomPaging>
                  </BannerSlideItem>
                </Link>
              );
            })}
          </BannerSlider>
        </>
      ) : (
        ""
      )}
    </div>
  );
};

const BannerSlider = styled(Slider)`
  padding-left: 15px;
  .slick-slide {
    padding-right: 15px;
    &:nth-child(1),
    &:nth-child(1n) {
      .bg-img {
        background-image: url(${Bg01});
      }
    }
    &:nth-child(2),
    &:nth-child(2n) {
      .bg-img {
        background-image: url(${Bg02});
      }
    }
    &:nth-child(3),
    &:nth-child(3n) {
      .bg-img {
        background-image: url(${Bg03});
      }
    }
    &:nth-child(4),
    &:nth-child(4n) {
      .bg-img {
        background-image: url(${Bg04});
      }
    }
    &:nth-child(5),
    &:nth-child(5n) {
      .bg-img {
        background-image: url(${Bg05});
      }
    }
  }
  .slick-dots {
    position: absolute;
    bottom: 16px;
    right: 15px;
    display: inline-block;
    width: auto;
    padding: 0;
    margin: 0;
    list-style: none;
    text-align: center;
  }
`;

const BannerSlideItem = styled.div`
  position: relative;
  overflow: hidden;
  width: 100%;
  height: 80px;
  border-radius: 4px;
  > div {
    z-index: 1;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    padding: 16px 15px;
    background-repeat: no-repeat;
    background-size: cover;
    color: #ffffff;
    font-size: 14px;
    transition: all 500ms;
    .title {
      ${({ theme }) => theme.textOverflow.singleLine()}
      margin-bottom: 8px;
      font-size: 16px;
      font-weight: 500;
      line-height: 20px;
    }
    .date {
      font-family: "Poppins";
      font-size: 12px;
      line-height: 20px;
    }
    .cmt {
      padding-left: 4px;
      margin-left: 16px;
      font-family: "Poppins";
      font-size: 12px;
      line-height: 20px;
      > svg {
        position: relative;
        left: -4px;
        top: -1px;
      }
    }
  }
`;

const CustomPaging = styled.p`
  z-index: 1;
  position: absolute;
  right: 15px;
  bottom: 18px;
  color: ${({ theme }) => theme.color.quaternary};
  font-family: "Poppins";
  font-size: 12px;
  font-weight: 400;
  > span {
    position: relative;
    display: inline-block;
    padding-right: 8px;
    margin-right: 8px;
    color: #fff;
    font-weight: 700;
    &:after {
      content: "";
      display: block;
      position: absolute;
      right: -1px;
      top: 50%;
      width: 2px;
      height: 12px;
      margin-top: -6px;
      border-radius: 1px;
      background: ${({ theme }) => theme.color.lineSecondary};
    }
  }
`;

export default MainBanner;
